import { AbstractControl } from '@angular/forms';

export function fasterPayGbpBankDetailsValidator(sortCode = 'sortCode', accountNumber = 'accountNumber', iban = 'iban') {
    return (frm: AbstractControl) => {
        return frm.get(iban).value || (frm.get(sortCode).value && frm.get(accountNumber).value)
            ? null
            : {
                bankDetailsError: true
            };
    };
}
